import { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { API } from '@src/lib/api_path'
import { MemberActions } from '@src/routes/members/components/account/member-actions'
import { MemberProfile } from '@src/data/member-profile'
import SessionManager from '@src/lib/session_manager'
import { Button } from '@src/elements/button/button'

@Component({
  computed: {
    member () {
      return this.$store.state.memberProfile
    }
  }
})
export class DeleteMemberAction extends MemberActions {

  protected member: MemberProfile

  trash (confirm) {
    if (confirm === true) {
      return this.apiClient.delete(API.MEMBERS_API.MEMBER_TRASH)
        .then(() => {
          SessionManager.Instance.logout()
          this.$router.push('/')
        })
        .catch((error) => console.log('cannot trash member', error))
    }
    this.hidePopup()
  }

  renderBlockActions (h: CreateElement) {
    return null
  }

  renderDeleteAction (h: CreateElement) {
    return <Button class='trash-btn' ref='trash-btn' label={this.$t('DELETE')} click={this.showTrashConfirm} type='elevated' />
  }

}
